import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { TextField, InputAdornment, Autocomplete, } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import "./NewContact.css";
import { getSessionList, getContactList } from "../Store/Actions/ChatAction";
import { toast } from "react-toastify";

const NewChat = ({ onClose, sendMessage, parentMsgParam }) => {
  const [disable, setDisable] = useState(false);
  //DIFFERENT LIST FOR SEARCHING CONTACTNAME AND NUMBER
  const [contactList, setContactList] = useState([]);
  const [numberList, setNumberList] = useState([]);

  const [sessions, setSessions] = useState([]);
  const [msgParam, setMsgParam] = useState({
    ...parentMsgParam,
    newchat: true,
  });

  function getContactsNewChat(type) {
    setContactList([]);
    setNumberList([]);

    if (
      (type === "contactname" &&
        msgParam.contactname !== undefined &&
        msgParam.contactname.length < 3) ||
      (type === "number" &&
        msgParam.number !== undefined &&
        msgParam.number.length < 5)
    ) {
      return;
    }

    let param =
      type === "contactname"
        ? msgParam.contactname
        : type === "number"
          ? msgParam.number
          : "";

    getContactList(msgParam.session, type, param)
      .then((response) => {
        if (response.status) {
          let contactArray = [];
          if (response.data && response.data.length > 0) {
            response.data.forEach((c) => {
              let contact = {
                ContactID: c.ContactID,
                Name: c.Name,
                //MobileNo skip the if start with "62"
                MobileNo: c.MobileNo.startsWith("62")
                  ? c.MobileNo.substring(2)
                  : c.MobileNo,
              };
              contactArray.push(contact);
            });
            if (type === "contactname") setContactList(contactArray);
            if (type === "number") setNumberList(contactArray);
          }
        }
      })
      .catch((err) => {
        setContactList([]);
        setNumberList([]);
        toast.warn(err.error);
      });
  }

  function getSessionsNewChat() {
    setSessions([]);

    getSessionList()
      .then((response) => {
        if (response.status) {
          if (response.data && response.data.length > 1) {
            let sessionArray = [];
            response.data.forEach((s) => {
              let session = {
                InstanceID: s.InstanceID,
                WhatsappName: s.WhatsappName,
              };
              sessionArray.push(session);
            });
            setSessions(sessionArray);
          } else if (response.data && response.data.length === 1) {
            setSessions({
              InstanceID: response.data[0].InstanceID,
              WhatsappName: response.data[0].WhatsappName,
            });
            setMsgParam({
              ...msgParam,
              session: response.data[0].InstanceID,
            });
          }
        }
      })
      .catch((err) => {
        setSessions([]);
        toast.warn(err.error);
      });
  }

  function SyncNameNumber(e, evalue, reason, type) {
    if (e === null) return;
    let val,
      target = "";
    //reset >> Select dropdown option from autocomplete
    //clear >> clear autocomplete field
    if (reason !== "reset" && reason !== "clear") {
      inputHandle(e);
    } else if (reason === "clear" || (evalue && evalue.length === 0)) {
      //SHOULD CLEAR BOTH OR JUST 1 FIELD
      // setMsgParam({ ...msgParam, [type]: "" });
      setMsgParam({ ...msgParam, [type]: "" });
    } else {
      switch (type) {
        case "contactname":
          target = "number";
          val = contactList.find((x) => x.Name === evalue).MobileNo;
          break;
        case "number":
          target = "contactname";
          val = numberList.find((x) => x.MobileNo === evalue).Name;
          break;
      }
      setMsgParam({ ...msgParam, [target]: val, [type]: evalue });
    }
  }

  useEffect(() => {
    //SEARCH IF CONTACT/NUMBER EXISTS DATABASE
    if (msgParam.contactname) {
      getContactsNewChat("contactname");
    }

    if (msgParam.number) {
      getContactsNewChat("number");
    }
  }, [msgParam.contactname, msgParam.number]);

  useEffect(() => {
    //GET USER'S SESSION LIST
    getSessionsNewChat();
  }, []);

  const inputHandle = (e) => {
    if (e.target.id === "number") {
      let pattern = /^\d*$/;
      //STOP IF NOT NUMBER
      if (!pattern.test(e.target.value)) {
        return;
      }
    }
    setMsgParam({
      ...msgParam,
      [e.target.id]: e.target.value,
    });
  };

  const confirmNewChat = (e) => {
    e.preventDefault();

    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 2000);

    sendMessage(msgParam);
    onClose();
  };

  return (
    <div className="overlay">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="newChatmodalContainer"
      >
        <div className="newChatmodalRight">
          <CloseOutlinedIcon
            className="newChatcloseBtn"
            onClick={onClose}
          ></CloseOutlinedIcon>
          <div className="newChatcontent">
            <h1>New Contact</h1>
            <span className="lineSeparator"></span>
          </div>
          <div className="newChatformInput">
            <form
              onSubmit={confirmNewChat}
              component="form"
              sx={{
                "& > :not(style)": { m: 1, width: "25ch" },
                borderRadius: "20px",
              }}
              //noValidate
              autoComplete="off"
            >
              <ul>
                {msgParam.session !== "" && (
                  <div style={{ alignItems: "center" }}>
                    <li className="ContainerT1">
                      <Autocomplete
                        freeSolo
                        id="contactname"
                        value={msgParam.contactname}
                        inputValue={msgParam.contactname}
                        options={contactList.map((c) => c.Name)}
                        getOptionLabel={(option) => option.Name || option}
                        onInputChange={(e, value, reason) => {
                          SyncNameNumber(e, value, reason, "contactname");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            size="small"
                            sx={{ borderRadius: "16px", width: "100%" }}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <AccountCircle />
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            label="Contact Name"
                            placeholder="Contact Name"
                            value={msgParam.contactname}
                          />
                        )}
                      />
                    </li>
                    <li className="ContainerT1">
                      <Autocomplete
                        freeSolo
                        id="number"
                        value={msgParam.number}
                        inputValue={msgParam.number}
                        options={numberList.map((c) => c.MobileNo)}
                        getOptionLabel={(option) => option.MobileNo || option}
                        onInputChange={(e, value, reason) => {
                          SyncNameNumber(e, value, reason, "number");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            size="small"
                            sx={{ borderRadius: "16px", width: "100%" }}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <span>+62</span>
                                </InputAdornment>
                              ),
                            }}
                            variant="outlined"
                            label="Contact Number"
                            placeholder="Contact Number"
                            value={msgParam.number}
                          />
                        )}
                      />
                    </li>
                  </div>
                )}
              </ul>
              <div className="newChatbtnContainer">
                <button
                  className="newChatbtn_Confirm"
                  type="submit"
                  disabled={disable}
                >
                  {disable && (
                    <i
                      className="fa fa-circle-o-notch fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  {disable ? <span>Loading...</span> : <span>Confirm</span>}
                </button>
                <button className="newChatbtn_Cancel" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewChat;
